import { Grid2 as Grid } from "@mui/material";
import { GridApi, GridReadyEvent, themeMaterial } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useEffect, useState } from "react";
import { CustomLoadingOverlay } from "../../../../../controls/customLoader/CustomCircularProgress";
import { L3ChemistryModel } from "../../../models/L3ChemistryModel";
import { useTableData } from "./hooks";

type Props = {
	rows: L3ChemistryModel[];
	loadingGrid: boolean;
	OnSend?: Function;
};
export const TableL3Chemistry = ({ rows, loadingGrid, OnSend }: Props) => {
	const [gridApi, setGridApi] = useState<GridApi>();
	const send_data = (data: L3ChemistryModel) => {
		if (OnSend) OnSend(data);
	};
	const { columns } = useTableData({ onSend: send_data });

	const onGridReady = (params: GridReadyEvent) => {
		setGridApi(params.api);
	};

	useEffect(() => {
		if (loadingGrid && gridApi) {
			gridApi.showLoadingOverlay();
		} else {
			gridApi?.hideOverlay();
		}
	}, [loadingGrid, gridApi]);
	return (
		<div>
			<Grid container>
				<Grid
					style={{
						borderRadius: 10,
						height: "calc(100vh - 300px)",
						minHeight: "calc(100vh - 300px)",
						border: "1px solid #E0E0E0",
					}}
					size={{ xs: 12, md: 12 }}
				>
					<AgGridReact
						onGridReady={onGridReady}
						rowSelection="single"
						pagination={false}
						animateRows={true}
						singleClickEdit={true}
						tooltipShowDelay={0}
						tooltipHideDelay={2000}
						rowData={rows}
						columnDefs={columns}
						loadingOverlayComponent={CustomLoadingOverlay}
					></AgGridReact>
				</Grid>
			</Grid>
		</div>
	);
};
